import * as React from "react";
//import styles from './FinishExam.css';
import { v4 } from "uuid";

import { withStyles, WithStyles, createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';

import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
//import '../../resources/img/bg1.jpg';
import { ThemeProvider } from '@material-ui/core/styles';

import { createMuiTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import TextField from '@material-ui/core/TextField';

import ExamServer from '../server/ExamServer'
import SpellcheckIcon from '@material-ui/icons/Spellcheck';
import AlarmIcon from '@material-ui/icons/Alarm';
import SchoolIcon from '@material-ui/icons/School';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import Chip from '@material-ui/core/Chip';
import Divider from '@material-ui/core/Divider';
import Fab from '@material-ui/core/Fab';
import CheckIcon from '@material-ui/icons/Check';

import ResponsivePaper from "./ResponsivePaper";


const theme = createMuiTheme({
    // palette: {
    //     primary: {
    //         main: '#44423e'
    //     },
    //     secondary: {
    //         main: '#FDC400',
    //         contrastText: '#fff'
    //     }
    // }

});


const styles = ((theme: Theme) => createStyles({
    root: {
        padding: theme.spacing(2)
    }
}))



export interface FinishExamProps extends WithStyles<typeof styles> {
    timeexceeded: boolean
}

export interface FinishExamState {
}


class FinishExam extends React.Component<FinishExamProps, FinishExamState> {


    constructor(props: FinishExamProps) {
        super(props);


    }


    render() {

        const { classes, timeexceeded } = this.props;

        return (
            <React.Fragment>
                {timeexceeded?(
                    <ResponsivePaper>
                        {/* <Typography variant="h5" color="textPrimary" component="h5" align="center" gutterBottom>
                            Your Time Limit Has Been Exceeded
                        </Typography> */}


                        <Typography variant="subtitle1" color="primary" component="p" align="center">
                            <AlarmIcon style={{ fontSize: 60 }} />
                        </Typography>
                        <Typography variant="subtitle1" color="primary" component="p" gutterBottom align="center">
                            Your Time Limit Has Been Exceeded
                        </Typography>
                        
                        <Typography variant="h5" color="textPrimary" component="h5" align="center">
                            Thank you for your understanding
                        </Typography>


                        {/* <Typography variant="subtitle1" color="textSecondary" component="p" gutterBottom style={{ width: "400px" }}>
                            You can start your graduading test now.
                            Please note that you have 35 min time for your test.
                        </Typography> */}



                    </ResponsivePaper>

                ):(
                    <ResponsivePaper>
                        {/* <Typography variant="h5" color="textPrimary" component="h5" align="center">
                            Congratulations
                        </Typography>


                        <Typography variant="subtitle1" color="textSecondary" component="p" gutterBottom style={{ width: "400px" }}>
                            You can start your graduading test now.
                            Please note that you have 35 min time for your test.
                        </Typography> */}


                        <Typography variant="subtitle1" color="primary" component="p" align="center">
                            <SchoolIcon style={{ fontSize: 60 }} />
                        </Typography>

                        <Typography variant="subtitle1" color="primary" component="p" gutterBottom align="center">
                            Congratulations you have finished your test
                        </Typography>

                        <Typography variant="h5" color="textPrimary" component="h5" align="center">
                            Thank you
                        </Typography>

                    </ResponsivePaper>
                )}
                



                {/* <Typography variant="subtitle1" color="textSecondary" component="p" style={{marginTop:theme.spacing(5)}}>
                    Please enter your Name
                </Typography> */}

                {/* <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    //onClickCapture={}
                    disabled={this.state.loading || this.state.searchText.length < 1}
                >
                    Start Exam
                </Button> */}

            </React.Fragment>


        )
    }
}

export default withStyles(styles)(FinishExam);
